import { WSQueryConfig } from "@ws-react-query";
import { IMergedRateCard } from "@wingspanhq/payments/dist/interfaces";
import { getPayeeEngagementRateCardByPayee } from "../../../services/rateCards/getPayeeEngagementRateCardByPayee";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_PAYEE_ENGAGEMENT_RATE_CARD_BY_PAYEE } from "../keys";

export const useQueryPayeeEngagementRateCardByPayee = (
  payeeId: string | undefined,
  payeeEngagementId: string | undefined,
  config?: WSQueryConfig<IMergedRateCard | null, WSServiceError>
) => {
  return useWSQuery<IMergedRateCard | null, WSServiceError>(
    [QUERY_PAYEE_ENGAGEMENT_RATE_CARD_BY_PAYEE, payeeId, payeeEngagementId],
    async () => {
      if (!payeeId || !payeeEngagementId) {
        throw new Error("payeeId and payeeEngagementId are required");
      }
      return await getPayeeEngagementRateCardByPayee(
        payeeId,
        payeeEngagementId
      );
    },
    {
      enabled: !!payeeId && !!payeeEngagementId,
      ...config
    }
  );
};
